import DetailRAE from './DetailRAE';

export default DetailRAE